const addMathsQuestions = [

{
  question: "Simplify: √18",
  options: ["3√2", "9√2", "6√3", "2√9"],
  answer: "3√2"
},
{
  question: "Simplify: √50",
  options: ["5√2", "10√5", "25√2", "2√25"],
  answer: "5√2"
},
{
  question: "Simplify: (√3)(√12)",
  options: ["6", "12", "3", "√36"],
  answer: "6"
},
{
  question: "Simplify: √8 + √18",
  options: ["5√2", "6√2", "4√2", "3√2"],
  answer: "5√2"
},
{
  question: "Rationalize: 1/√5",
  options: ["√5/5", "1/5", "√5", "5"],
  answer: "√5/5"
},
{
  question: "Rationalize: 3/√7",
  options: ["3√7/7", "√7/3", "3/7", "7√3"],
  answer: "3√7/7"
},
{
  question: "Simplify: (2 + √3)(2 − √3)",
  options: ["1", "4 − 3", "7", "5"],
  answer: "1"
},
{
  question: "Simplify: √20 − √5",
  options: ["√5", "2√5", "3√5", "4√5"],
  answer: "√5"
},
{
  question: "Simplify: (√2 + √3)^2",
  options: ["5 + 2√6", "5 + √6", "2 + 3√6", "5"],
  answer: "5 + 2√6"
},
{
  question: "Simplify: (√5 − √2)^2",
  options: ["7 − 2√10", "3", "5 − 2√2", "7"],
  answer: "7 − 2√10"
},
{
  question: "Simplify: √45 ÷ √5",
  options: ["3", "9", "√9", "5"],
  answer: "3"
},
{
  question: "Simplify: √75 ÷ √3",
  options: ["5", "25", "√25", "15"],
  answer: "5"
},
{
  question: "Simplify: (√6)(√10)",
  options: ["√60", "2√15", "√16", "6√10"],
  answer: "2√15"
},
{
  question: "Rationalize: 1/(√3 + √2)",
  options: ["√3 − √2", "1/(√3 − √2)", "√3 + √2", "2"],
  answer: "√3 − √2"
},
{
  question: "Simplify: (√7 + √5)(√7 − √5)",
  options: ["2", "49 − 25", "24", "12"],
  answer: "24"
},
{
  question: "Simplify: √12 + √27",
  options: ["5√3", "6√3", "4√3", "3√3"],
  answer: "5√3"
},
{
  question: "Simplify: √32",
  options: ["4√2", "8√2", "16√2", "2√8"],
  answer: "4√2"
},
{
  question: "Simplify: √48",
  options: ["4√3", "8√3", "2√12", "6√3"],
  answer: "4√3"
},
{
  question: "Simplify: (√2 + 1)(√2 − 1)",
  options: ["1", "2", "3", "0"],
  answer: "1"
},
{
  question: "Simplify: (3 + √2)(3 − √2)",
  options: ["7", "9 − 2", "11", "5"],
  answer: "7"
},
{
  question: "Simplify: √98",
  options: ["7√2", "14√2", "49√2", "2√49"],
  answer: "7√2"
},
{
  question: "Simplify: √72",
  options: ["6√2", "12√2", "36√2", "4√18"],
  answer: "6√2"
},
{
  question: "Simplify: √27 + √12",
  options: ["5√3", "6√3", "4√3", "7√3"],
  answer: "5√3"
},
{
  question: "Simplify: √125",
  options: ["5√5", "25√5", "10√5", "√25"],
  answer: "5√5"
},
{
  question: "Simplify: √(49/9)",
  options: ["7/3", "49/3", "7/9", "3/7"],
  answer: "7/3"
},
{
  question: "Simplify: √(16/25)",
  options: ["4/5", "16/5", "2/5", "5/4"],
  answer: "4/5"
},
{
  question: "Simplify: (√3)^2 + (√4)^2",
  options: ["7", "5", "3", "6"],
  answer: "7"
},
{
  question: "Simplify: √81 − √16",
  options: ["5", "9", "65", "7"],
  answer: "5"
},
{
  question: "Simplify: (√9 + √4)^2",
  options: ["49", "25", "13", "36"],
  answer: "49"
},
{
  question: "Simplify: (√16 − √9)^2",
  options: ["1", "7", "25", "49"],
  answer: "1"
},

{
  question: "If n(A)=20, n(B)=15, n(A∩B)=5, find n(A∪B)",
  options: ["30", "25", "35", "40"],
  answer: "30"
},
{
  question: "If n(U)=50, n(A)=20, n(B)=25, n(A∩B)=10, find n(A'∩B')",
  options: ["15", "10", "5", "20"],
  answer: "15"
},
{
  question: "If n(A∪B)=40, n(A)=25, n(B)=20, find n(A∩B)",
  options: ["5", "10", "15", "20"],
  answer: "5"
},
{
  question: "If n(A)=30, n(B)=20, n(C)=15, n(A∩B)=10, n(B∩C)=5, n(A∩C)=6, n(A∩B∩C)=3, find n(A∪B∪C)",
  options: ["47", "48", "49", "50"],
  answer: "47"
},
{
  question: "If A={1,2,3}, B={2,3,4}, find A∩B",
  options: ["{2,3}", "{1,2}", "{3,4}", "{1,4}"],
  answer: "{2,3}"
},
{
  question: "If A={1,2,3}, B={2,3,4}, find A∪B",
  options: ["{1,2,3,4}", "{2,3}", "{1,4}", "{1,2,3}"],
  answer: "{1,2,3,4}"
},
{
  question: "If U={1,2,3,4,5}, A={2,3}, find A'",
  options: ["{1,4,5}", "{2,3}", "{1,2}", "{4,5}"],
  answer: "{1,4,5}"
},
{
  question: "If A={1,2,3,4}, B={3,4,5,6}, find A−B",
  options: ["{1,2}", "{3,4}", "{5,6}", "{1,6}"],
  answer: "{1,2}"
},
{
  question: "If A={1,2,3,4}, B={3,4,5,6}, find B−A",
  options: ["{5,6}", "{1,2}", "{3,4}", "{6}"],
  answer: "{5,6}"
},
{
  question: "If n(U)=60, n(A)=25, find n(A')",
  options: ["35", "25", "60", "30"],
  answer: "35"
},
{
  question: "If f(x)=2x+3, find f(5)",
  options: ["13", "10", "7", "8"],
  answer: "13"
},
{
  question: "If f(x)=x²−1, find f(3)",
  options: ["8", "9", "10", "7"],
  answer: "8"
},
{
  question: "If g(x)=3x−2, find g(4)",
  options: ["10", "12", "14", "8"],
  answer: "10"
},
{
  question: "If f(x)=2x+1, g(x)=x², find (f∘g)(2)",
  options: ["9", "5", "8", "6"],
  answer: "9"
},
{
  question: "If f(x)=x+2, g(x)=2x, find (g∘f)(3)",
  options: ["10", "8", "12", "6"],
  answer: "10"
},
{
  question: "If f(x)=x², find f⁻¹(x)",
  options: ["√x", "x²", "1/x", "x"],
  answer: "√x"
},
{
  question: "If f(x)=3x, find f⁻¹(x)",
  options: ["x/3", "3x", "1/x", "x²"],
  answer: "x/3"
},
{
  question: "If f(x)=2x+5, find f⁻¹(x)",
  options: ["(x−5)/2", "(x+5)/2", "2x−5", "x/2"],
  answer: "(x−5)/2"
},
{
  question: "Find domain of f(x)=1/(x−2)",
  options: ["x≠2", "x=2", "all x", "x>2"],
  answer: "x≠2"
},
{
  question: "Find domain of f(x)=√(x−3)",
  options: ["x≥3", "x>3", "x≤3", "all x"],
  answer: "x≥3"
},
{
  question: "Find range of f(x)=x²",
  options: ["y≥0", "all y", "y≤0", "y>0"],
  answer: "y≥0"
},
{
  question: "If f(x)=x+1, find f(2)+f(3)",
  options: ["7", "6", "5", "8"],
  answer: "7"
},
{
  question: "If f(x)=x², find f(2)+f(3)",
  options: ["13", "10", "9", "8"],
  answer: "13"
},
{
  question: "If f(x)=x−1, g(x)=x+2, find f(g(3))",
  options: ["4", "5", "6", "3"],
  answer: "4"
},
{
  question: "If f(x)=2x, g(x)=x+1, find g(f(2))",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "If f(x)=x²+1, find f(−2)",
  options: ["5", "3", "4", "6"],
  answer: "5"
},
{
  question: "If f(x)=x³, find f(−2)",
  options: ["−8", "8", "4", "−4"],
  answer: "−8"
},
{
  question: "If f(x)=2x−3, find x when f(x)=5",
  options: ["4", "3", "2", "1"],
  answer: "4"
},
{
  question: "If f(x)=x², find x when f(x)=16",
  options: ["±4", "4", "−4", "±8"],
  answer: "±4"
},
{
  question: "If f(x)=3x+2, find x when f(x)=11",
  options: ["3", "2", "4", "5"],
  answer: "3"
},

{
  question: "Solve: x² − 5x + 6 = 0",
  options: ["2,3", "1,6", "−2,−3", "−1,−6"],
  answer: "2,3"
},
{
  question: "Solve: x² − 9 = 0",
  options: ["±3", "3", "−3", "±9"],
  answer: "±3"
},
{
  question: "Solve: x² + 7x + 10 = 0",
  options: ["−5,−2", "5,2", "−10,−1", "10,1"],
  answer: "−5,−2"
},
{
  question: "Solve: 2x² − 7x + 3 = 0",
  options: ["3,1/2", "−3,−1/2", "1,3", "−1,−3"],
  answer: "3,1/2"
},
{
  question: "Solve: x² − 4x − 5 = 0",
  options: ["5,−1", "−5,1", "5,1", "−5,−1"],
  answer: "5,−1"
},
{
  question: "Find discriminant of x² − 4x + 4",
  options: ["0", "16", "8", "4"],
  answer: "0"
},
{
  question: "Find discriminant of x² + 2x + 5",
  options: ["−16", "4", "16", "−4"],
  answer: "−16"
},
{
  question: "Nature of roots if discriminant < 0:",
  options: ["complex", "real equal", "real distinct", "zero"],
  answer: "complex"
},
{
  question: "Nature of roots if discriminant = 0:",
  options: ["equal", "complex", "distinct", "negative"],
  answer: "equal"
},
{
  question: "Nature of roots if discriminant > 0:",
  options: ["real distinct", "equal", "complex", "zero"],
  answer: "real distinct"
},
{
  question: "Solve: x² + x − 12 = 0",
  options: ["3,−4", "4,−3", "6,−2", "−6,2"],
  answer: "3,−4"
},
{
  question: "Solve: 3x² − 12x = 0",
  options: ["0,4", "1,3", "2,6", "−2,−6"],
  answer: "0,4"
},
{
  question: "Solve: x² − 2x − 8 = 0",
  options: ["4,−2", "−4,2", "8,−1", "−8,1"],
  answer: "4,−2"
},
{
  question: "If α and β are roots of x² − 5x + 6=0, α+β:",
  options: ["5", "6", "−5", "−6"],
  answer: "5"
},
{
  question: "If α and β are roots of x² − 5x + 6=0, αβ:",
  options: ["6", "5", "−6", "−5"],
  answer: "6"
},
{
  question: "Find equation with roots 2 and 3",
  options: ["x²−5x+6=0", "x²+5x+6=0", "x²−6x+5=0", "x²+6x+5=0"],
  answer: "x²−5x+6=0"
},
{
  question: "Find equation with roots −1 and 4",
  options: ["x²−3x−4=0", "x²+3x−4=0", "x²−4x−1=0", "x²+4x−1=0"],
  answer: "x²−3x−4=0"
},
{
  question: "Factor: x³ − 3x² − 4x + 12",
  options: ["(x−3)(x²−4)", "(x+3)(x²−4)", "(x−3)(x²+4)", "(x+3)(x²+4)"],
  answer: "(x−3)(x²−4)"
},
{
  question: "If f(x)=x³−4x, find f(2)",
  options: ["0", "8", "4", "−4"],
  answer: "0"
},
{
  question: "If f(1)=0 for f(x)=x³+ax²+bx+1, find a+b",
  options: ["−2", "2", "−1", "1"],
  answer: "−2"
},
{
  question: "Remainder when x³−2x²+3 divided by (x−1)",
  options: ["2", "1", "0", "3"],
  answer: "2"
},
{
  question: "If (x−2) is factor of x³−ax²+bx−8, find a+b",
  options: ["12", "10", "8", "6"],
  answer: "12"
},
{
  question: "Solve: x² = 16",
  options: ["±4", "4", "−4", "±8"],
  answer: "±4"
},
{
  question: "Solve: 2x² = 18",
  options: ["±3", "±9", "3", "9"],
  answer: "±3"
},
{
  question: "Solve: x² − 6x + 9 = 0",
  options: ["3", "−3", "±3", "6"],
  answer: "3"
},
{
  question: "Factor: x² − 16",
  options: ["(x−4)(x+4)", "(x−8)(x+2)", "(x−2)(x+8)", "(x−16)(x+1)"],
  answer: "(x−4)(x+4)"
},
{
  question: "Solve: x² + 4x = 0",
  options: ["0,−4", "4,0", "−2,2", "1,−4"],
  answer: "0,−4"
},
{
  question: "Solve: x² − x − 20 = 0",
  options: ["5,−4", "−5,4", "10,−2", "−10,2"],
  answer: "5,−4"
},
{
  question: "If roots are 1 and −6, equation:",
  options: ["x²+5x−6=0", "x²−5x−6=0", "x²+6x−1=0", "x²−6x+1=0"],
  answer: "x²+5x−6=0"
},
{
  question: "Solve: x² − 3x + 2 = 0",
  options: ["1,2", "−1,−2", "2,−1", "−2,1"],
  answer: "1,2"
},

{
  question: "Expand: (x + 2)^2",
  options: ["x² + 4x + 4", "x² + 2x + 4", "x² + 4", "x² + 2x"],
  answer: "x² + 4x + 4"
},
{
  question: "Expand: (x − 3)^2",
  options: ["x² − 6x + 9", "x² − 3x + 9", "x² − 6x − 9", "x² + 6x + 9"],
  answer: "x² − 6x + 9"
},
{
  question: "Expand: (2x + 1)^2",
  options: ["4x² + 4x + 1", "4x² + 2x + 1", "2x² + 4x + 1", "4x² + 1"],
  answer: "4x² + 4x + 1"
},
{
  question: "Expand: (x + 1)^3",
  options: ["x³ + 3x² + 3x + 1", "x³ + x² + x + 1", "x³ + 3x + 1", "x³ + 1"],
  answer: "x³ + 3x² + 3x + 1"
},
{
  question: "Expand: (x − 2)^3",
  options: ["x³ − 6x² + 12x − 8", "x³ − 2x² + 4x − 8", "x³ − 6x² + 8", "x³ − 2x³"],
  answer: "x³ − 6x² + 12x − 8"
},
{
  question: "Coefficient of x² in (x + 2)^3",
  options: ["6", "3", "2", "4"],
  answer: "6"
},
{
  question: "Constant term in (x − 1)^3",
  options: ["−1", "1", "0", "−3"],
  answer: "−1"
},
{
  question: "Coefficient of x in (2x + 1)^3",
  options: ["6", "12", "3", "8"],
  answer: "12"
},
{
  question: "Expand: (1 + 3x)^2",
  options: ["1 + 6x + 9x²", "1 + 3x + 9x²", "1 + 9x²", "1 + 6x"],
  answer: "1 + 6x + 9x²"
},
{
  question: "Expand: (2 + x)^3",
  options: ["8 + 12x + 6x² + x³", "8 + 6x + x³", "2 + x³", "4 + x³"],
  answer: "8 + 12x + 6x² + x³"
},
{
  question: "Solve: 2x − 5 > 3",
  options: ["x > 4", "x > 2", "x < 4", "x < 2"],
  answer: "x > 4"
},
{
  question: "Solve: 3x + 2 ≤ 11",
  options: ["x ≤ 3", "x ≥ 3", "x < 3", "x > 3"],
  answer: "x ≤ 3"
},
{
  question: "Solve: 5 − x > 2",
  options: ["x < 3", "x > 3", "x < 2", "x > 2"],
  answer: "x < 3"
},
{
  question: "Solve: 2x + 1 < 7",
  options: ["x < 3", "x > 3", "x < 4", "x > 4"],
  answer: "x < 3"
},
{
  question: "Solve: 4x − 3 ≥ 5",
  options: ["x ≥ 2", "x ≤ 2", "x > 2", "x < 2"],
  answer: "x ≥ 2"
},
{
  question: "Solve: x² − 4 < 0",
  options: ["−2 < x < 2", "x > 2", "x < −2", "x ≥ 2"],
  answer: "−2 < x < 2"
},
{
  question: "Solve: x² − 9 > 0",
  options: ["x < −3 or x > 3", "−3 < x < 3", "x > 3", "x < 3"],
  answer: "x < −3 or x > 3"
},
{
  question: "Solve: x² + 2x − 3 ≥ 0",
  options: ["x ≤ −3 or x ≥ 1", "−3 < x < 1", "x ≥ −3", "x ≤ 1"],
  answer: "x ≤ −3 or x ≥ 1"
},
{
  question: "Solve: x² − x − 6 ≤ 0",
  options: ["−2 ≤ x ≤ 3", "x ≤ −2 or x ≥ 3", "x ≥ −2", "x ≤ 3"],
  answer: "−2 ≤ x ≤ 3"
},
{
  question: "Solve: x² + x − 2 > 0",
  options: ["x < −2 or x > 1", "−2 < x < 1", "x > 2", "x < 1"],
  answer: "x < −2 or x > 1"
},
{
  question: "If (1 + x)^n expansion has 6 terms, n =",
  options: ["5", "6", "4", "7"],
  answer: "5"
},
{
  question: "Coefficient of x³ in (x + 1)^4",
  options: ["4", "6", "3", "1"],
  answer: "4"
},
{
  question: "Constant term in (2x + 3)^2",
  options: ["9", "4", "6", "12"],
  answer: "9"
},
{
  question: "Coefficient of x² in (2x + 1)^3",
  options: ["6", "12", "3", "8"],
  answer: "6"
},
{
  question: "Expand first 3 terms: (1 + x)^4",
  options: ["1 + 4x + 6x²", "1 + 4x + 4x²", "1 + x + x²", "1 + 2x + x²"],
  answer: "1 + 4x + 6x²"
},
{
  question: "Solve: 2x² − 8 ≥ 0",
  options: ["x ≤ −2 or x ≥ 2", "−2 ≤ x ≤ 2", "x ≥ 2", "x ≤ −2"],
  answer: "x ≤ −2 or x ≥ 2"
},
{
  question: "Solve: x² + 4x + 4 ≤ 0",
  options: ["x = −2", "x ≤ −2", "x ≥ −2", "all x"],
  answer: "x = −2"
},
{
  question: "Solve: x² − 5x + 6 > 0",
  options: ["x < 2 or x > 3", "2 < x < 3", "x > 3", "x < 2"],
  answer: "x < 2 or x > 3"
},
{
  question: "If coefficient of x in (1 + ax)^2 is 10, a =",
  options: ["5", "10", "2", "4"],
  answer: "5"
},
{
  question: "If constant term in (x + a)^2 is 16, a =",
  options: ["±4", "4", "−4", "16"],
  answer: "±4"
},

{
  question: "Find gradient between (1,2) and (3,6)",
  options: ["2", "1", "3", "4"],
  answer: "2"
},
{
  question: "Find gradient between (2,5) and (6,13)",
  options: ["2", "3", "4", "1"],
  answer: "2"
},
{
  question: "Find equation of line with slope 3 passing through (0,2)",
  options: ["y=3x+2", "y=2x+3", "y=3x−2", "y=2x−3"],
  answer: "y=3x+2"
},
{
  question: "Find equation of line through (1,2) with slope 2",
  options: ["y=2x", "y=2x+1", "y=2x−1", "y=2x+2"],
  answer: "y=2x"
},
{
  question: "Find distance between (0,0) and (3,4)",
  options: ["5", "7", "4", "6"],
  answer: "5"
},
{
  question: "Find midpoint of (2,4) and (6,8)",
  options: ["(4,6)", "(3,5)", "(5,7)", "(2,8)"],
  answer: "(4,6)"
},
{
  question: "Find equation of line parallel to y=2x+3 through (1,1)",
  options: ["y=2x−1", "y=2x+1", "y=3x+1", "y=x+1"],
  answer: "y=2x−1"
},
{
  question: "Find equation of line perpendicular to y=2x through origin",
  options: ["y=−1/2x", "y=2x", "y=1/2x", "y=−2x"],
  answer: "y=−1/2x"
},
{
  question: "Find slope of line 2x+3y=6",
  options: ["−2/3", "2/3", "−3/2", "3/2"],
  answer: "−2/3"
},
{
  question: "Find intercept of y=3x+6 on y-axis",
  options: ["6", "3", "−6", "0"],
  answer: "6"
},
{
  question: "Find x-intercept of y=2x−4",
  options: ["2", "−2", "4", "0"],
  answer: "2"
},
{
  question: "Find distance between (1,1) and (4,5)",
  options: ["5", "4", "3", "6"],
  answer: "5"
},
{
  question: "Find midpoint of (−2,4) and (2,6)",
  options: ["(0,5)", "(1,5)", "(0,4)", "(2,5)"],
  answer: "(0,5)"
},
{
  question: "Find gradient of line perpendicular to slope 3",
  options: ["−1/3", "3", "1/3", "−3"],
  answer: "−1/3"
},
{
  question: "Find equation of line through (0,−3) slope 4",
  options: ["y=4x−3", "y=4x+3", "y=3x−4", "y=4x"],
  answer: "y=4x−3"
},
{
  question: "Find distance between (2,3) and (2,7)",
  options: ["4", "5", "3", "2"],
  answer: "4"
},
{
  question: "Find gradient between (−1,2) and (3,6)",
  options: ["1", "2", "3", "4"],
  answer: "1"
},
{
  question: "Find equation of line through (2,3) and (4,7)",
  options: ["y=2x−1", "y=2x+1", "y=3x−1", "y=2x−3"],
  answer: "y=2x−1"
},
{
  question: "Find midpoint of (1,2) and (3,10)",
  options: ["(2,6)", "(1,6)", "(2,5)", "(3,6)"],
  answer: "(2,6)"
},
{
  question: "Find gradient of vertical line",
  options: ["undefined", "0", "1", "∞"],
  answer: "undefined"
},
{
  question: "Find gradient of horizontal line",
  options: ["0", "undefined", "1", "∞"],
  answer: "0"
},
{
  question: "Find equation of horizontal line through y=5",
  options: ["y=5", "x=5", "y=0", "x=0"],
  answer: "y=5"
},
{
  question: "Find equation of vertical line through x=3",
  options: ["x=3", "y=3", "x=0", "y=0"],
  answer: "x=3"
},
{
  question: "If midpoint is (3,4) and one point is (1,2), find other point",
  options: ["(5,6)", "(4,5)", "(3,6)", "(2,6)"],
  answer: "(5,6)"
},
{
  question: "Find equation of line with slope 1 passing through (2,2)",
  options: ["y=x", "y=x+2", "y=x−2", "y=2x"],
  answer: "y=x"
},
{
  question: "Find distance between (−1,−1) and (2,3)",
  options: ["5", "4", "3", "6"],
  answer: "5"
},
{
  question: "Find gradient between (0,3) and (3,3)",
  options: ["0", "1", "−1", "3"],
  answer: "0"
},
{
  question: "Find equation of line slope −2 through (0,4)",
  options: ["y=−2x+4", "y=2x+4", "y=−2x−4", "y=2x−4"],
  answer: "y=−2x+4"
},
{
  question: "Find midpoint of (0,0) and (4,4)",
  options: ["(2,2)", "(4,4)", "(0,0)", "(1,1)"],
  answer: "(2,2)"
},
{
  question: "Find distance between (−3,0) and (3,0)",
  options: ["6", "3", "9", "0"],
  answer: "6"
},

{
  question: "Find centre of circle (x−2)² + (y−3)² = 25",
  options: ["(2,3)", "(−2,−3)", "(5,5)", "(3,2)"],
  answer: "(2,3)"
},
{
  question: "Find radius of (x−2)² + (y−3)² = 25",
  options: ["5", "25", "10", "3"],
  answer: "5"
},
{
  question: "Find centre of x² + y² = 16",
  options: ["(0,0)", "(4,4)", "(2,2)", "(1,1)"],
  answer: "(0,0)"
},
{
  question: "Find radius of x² + y² = 16",
  options: ["4", "16", "8", "2"],
  answer: "4"
},
{
  question: "Find radius of x² + y² − 4x − 6y + 9 = 0",
  options: ["√( (2²+3²)−9 )", "√4", "5", "3"],
  answer: "√( (2²+3²)−9 )"
},
{
  question: "Find centre of x² + y² − 6x − 8y = 0",
  options: ["(3,4)", "(−3,−4)", "(6,8)", "(4,3)"],
  answer: "(3,4)"
},
{
  question: "Find radius of x² + y² − 6x − 8y = 0",
  options: ["5", "10", "4", "3"],
  answer: "5"
},
{
  question: "Find equation of circle centre (1,2) radius 3",
  options: ["(x−1)²+(y−2)²=9", "(x+1)²+(y+2)²=9", "(x−1)²+(y−2)²=3", "(x+1)²+(y−2)²=9"],
  answer: "(x−1)²+(y−2)²=9"
},
{
  question: "Find equation centre (0,0) radius 5",
  options: ["x²+y²=25", "x²+y²=5", "x²+y²=10", "x²+y²=20"],
  answer: "x²+y²=25"
},
{
  question: "Find equation centre (2,−1) radius 4",
  options: ["(x−2)²+(y+1)²=16", "(x+2)²+(y−1)²=16", "(x−2)²+(y−1)²=16", "(x+2)²+(y+1)²=16"],
  answer: "(x−2)²+(y+1)²=16"
},
{
  question: "Expand (x−1)²+(y−2)²=9",
  options: ["x²+y²−2x−4y−4=0", "x²+y²−2x−4y+5=0", "x²+y²+2x+4y−4=0", "x²+y²−2x−4y+1=0"],
  answer: "x²+y²−2x−4y−4=0"
},
{
  question: "Check if (3,4) lies on x²+y²=25",
  options: ["Yes", "No", "Maybe", "Undefined"],
  answer: "Yes"
},
{
  question: "Check if (2,2) lies on x²+y²=8",
  options: ["Yes", "No", "Undefined", "Maybe"],
  answer: "Yes"
},
{
  question: "Find distance from centre (0,0) to (3,4)",
  options: ["5", "7", "4", "6"],
  answer: "5"
},
{
  question: "Find diameter if radius = 6",
  options: ["12", "6", "18", "3"],
  answer: "12"
},
{
  question: "Find radius if diameter = 10",
  options: ["5", "10", "20", "2"],
  answer: "5"
},
{
  question: "Find centre of x²+y²+4x−6y+9=0",
  options: ["(−2,3)", "(2,−3)", "(−4,6)", "(4,−6)"],
  answer: "(−2,3)"
},
{
  question: "Find radius of x²+y²+4x−6y+9=0",
  options: ["√(4+9−9)", "√13", "5", "3"],
  answer: "√(4+9−9)"
},
{
  question: "If tangent at point is perpendicular to radius, angle is:",
  options: ["90°", "45°", "180°", "0°"],
  answer: "90°"
},
{
  question: "Equation of tangent to x²+y²=25 at (3,4)",
  options: ["3x+4y=25", "3x−4y=25", "4x+3y=25", "x+y=25"],
  answer: "3x+4y=25"
},
{
  question: "Find slope of radius to point (3,4)",
  options: ["4/3", "3/4", "−4/3", "−3/4"],
  answer: "4/3"
},
{
  question: "Slope of tangent at (3,4)",
  options: ["−3/4", "4/3", "3/4", "−4/3"],
  answer: "−3/4"
},
{
  question: "Find equation of tangent slope −1 through (2,3)",
  options: ["y=−x+5", "y=x+5", "y=−x−5", "y=x−5"],
  answer: "y=−x+5"
},
{
  question: "Find equation of circle diameter endpoints (0,0) and (4,0)",
  options: ["(x−2)²+y²=4", "(x+2)²+y²=4", "x²+y²=4", "x²+y²=16"],
  answer: "(x−2)²+y²=4"
},
{
  question: "Find centre midpoint of diameter (2,2) and (6,6)",
  options: ["(4,4)", "(2,6)", "(6,2)", "(3,3)"],
  answer: "(4,4)"
},
{
  question: "Find radius from endpoints (2,2) and (6,6)",
  options: ["2√2", "4√2", "2", "4"],
  answer: "2√2"
},
{
  question: "If circle centre (0,0) passes through (1,√3), radius:",
  options: ["2", "√2", "√3", "1"],
  answer: "2"
},
{
  question: "Find equation centre (0,0) passing (1,√3)",
  options: ["x²+y²=4", "x²+y²=3", "x²+y²=2", "x²+y²=1"],
  answer: "x²+y²=4"
},
{
  question: "Distance between centres (0,0) and (6,8)",
  options: ["10", "8", "6", "12"],
  answer: "10"
},
{
  question: "If two circles touch externally, distance =",
  options: ["sum of radii", "difference", "product", "zero"],
  answer: "sum of radii"
},

{
  question: "Evaluate: sin²30° + cos²30°",
  options: ["1", "0", "1/2", "2"],
  answer: "1"
},
{
  question: "Evaluate: sin 30°",
  options: ["1/2", "√3/2", "1", "0"],
  answer: "1/2"
},
{
  question: "Evaluate: cos 60°",
  options: ["1/2", "√3/2", "1", "0"],
  answer: "1/2"
},
{
  question: "Evaluate: tan 45°",
  options: ["1", "0", "√3", "2"],
  answer: "1"
},
{
  question: "Evaluate: sin 90°",
  options: ["1", "0", "1/2", "√3/2"],
  answer: "1"
},
{
  question: "Evaluate: cos 0°",
  options: ["1", "0", "1/2", "√3/2"],
  answer: "1"
},
{
  question: "Solve: sin x = 0 for 0°≤x≤360°",
  options: ["0°,180°,360°", "90°,270°", "45°,135°", "60°,120°"],
  answer: "0°,180°,360°"
},
{
  question: "Solve: cos x = 0 for 0°≤x≤360°",
  options: ["90°,270°", "0°,180°", "45°,135°", "60°,120°"],
  answer: "90°,270°"
},
{
  question: "Solve: tan x = 1 for 0°≤x≤360°",
  options: ["45°,225°", "90°,270°", "0°,180°", "30°,210°"],
  answer: "45°,225°"
},
{
  question: "Solve: sin x = 1/2",
  options: ["30°,150°", "45°,135°", "60°,120°", "0°,180°"],
  answer: "30°,150°"
},
{
  question: "Solve: cos x = 1/2",
  options: ["60°,300°", "30°,150°", "45°,315°", "90°,270°"],
  answer: "60°,300°"
},
{
  question: "Solve: tan x = √3",
  options: ["60°,240°", "30°,210°", "45°,225°", "90°,270°"],
  answer: "60°,240°"
},
{
  question: "If sin x = 3/5, cos x =",
  options: ["4/5", "5/4", "3/4", "√2"],
  answer: "4/5"
},
{
  question: "If cos x = 5/13, sin x =",
  options: ["12/13", "5/12", "13/5", "√5"],
  answer: "12/13"
},
{
  question: "Simplify: (sin x)/(cos x)",
  options: ["tan x", "cot x", "sec x", "cosec x"],
  answer: "tan x"
},
{
  question: "Simplify: (1)/(cos x)",
  options: ["sec x", "cosec x", "tan x", "cot x"],
  answer: "sec x"
},
{
  question: "Simplify: (1)/(sin x)",
  options: ["cosec x", "sec x", "tan x", "cot x"],
  answer: "cosec x"
},
{
  question: "Evaluate: sin²45°",
  options: ["1/2", "1", "√2", "2"],
  answer: "1/2"
},
{
  question: "Evaluate: cos²45°",
  options: ["1/2", "1", "√2", "2"],
  answer: "1/2"
},
{
  question: "Solve: 2sin x = 1",
  options: ["30°,150°", "45°,135°", "60°,120°", "0°,180°"],
  answer: "30°,150°"
},
{
  question: "Solve: 2cos x = √3",
  options: ["30°,330°", "60°,300°", "45°,315°", "90°,270°"],
  answer: "30°,330°"
},
{
  question: "Solve: tan x = 0",
  options: ["0°,180°,360°", "90°,270°", "45°,225°", "30°,210°"],
  answer: "0°,180°,360°"
},
{
  question: "If tan x = 3/4, sin x =",
  options: ["3/5", "4/5", "5/3", "5/4"],
  answer: "3/5"
},
{
  question: "If tan x = 3/4, cos x =",
  options: ["4/5", "3/5", "5/4", "5/3"],
  answer: "4/5"
},
{
  question: "Evaluate: sin 60°",
  options: ["√3/2", "1/2", "1", "0"],
  answer: "√3/2"
},
{
  question: "Evaluate: cos 30°",
  options: ["√3/2", "1/2", "1", "0"],
  answer: "√3/2"
},
{
  question: "Evaluate: tan 60°",
  options: ["√3", "1", "1/√3", "2"],
  answer: "√3"
},
{
  question: "Evaluate: tan 30°",
  options: ["1/√3", "√3", "1", "0"],
  answer: "1/√3"
},
{
  question: "If sin x = 1, x =",
  options: ["90°", "0°", "180°", "270°"],
  answer: "90°"
},
{
  question: "If cos x = −1, x =",
  options: ["180°", "0°", "90°", "270°"],
  answer: "180°"
},

{
  question: "Solve: sin2x = 0 for 0°≤x≤360°",
  options: ["0°,90°,180°,270°,360°", "45°,135°", "30°,150°", "60°,120°"],
  answer: "0°,90°,180°,270°,360°"
},
{
  question: "Solve: cos2x = 1",
  options: ["0°,180°,360°", "90°,270°", "45°,135°", "30°,150°"],
  answer: "0°,180°,360°"
},
{
  question: "Solve: sin2x = 1",
  options: ["45°,225°", "90°,270°", "30°,150°", "60°,120°"],
  answer: "45°,225°"
},
{
  question: "Solve: cos2x = 0",
  options: ["45°,135°,225°,315°", "90°,270°", "0°,180°", "30°,150°"],
  answer: "45°,135°,225°,315°"
},
{
  question: "Solve: tan2x = 0",
  options: ["0°,90°,180°,270°,360°", "45°,225°", "90°,270°", "30°,150°"],
  answer: "0°,90°,180°,270°,360°"
},
{
  question: "Solve: sin²x = 1/4",
  options: ["30°,150°,210°,330°", "45°,135°", "60°,120°", "0°,180°"],
  answer: "30°,150°,210°,330°"
},
{
  question: "Solve: cos²x = 1/2",
  options: ["45°,135°,225°,315°", "30°,150°", "60°,120°", "0°,180°"],
  answer: "45°,135°,225°,315°"
},
{
  question: "Solve: tan²x = 1",
  options: ["45°,135°,225°,315°", "30°,150°", "60°,120°", "0°,180°"],
  answer: "45°,135°,225°,315°"
},
{
  question: "Solve: sin x cos x = 0",
  options: ["0°,90°,180°,270°,360°", "45°,135°", "30°,150°", "60°,120°"],
  answer: "0°,90°,180°,270°,360°"
},
{
  question: "Solve: 2sin x cos x = 1",
  options: ["45°,135°", "30°,150°", "60°,120°", "0°,180°"],
  answer: "45°,135°"
},
{
  question: "Solve: sin x = cos x",
  options: ["45°,225°", "30°,150°", "60°,120°", "90°,270°"],
  answer: "45°,225°"
},
{
  question: "Solve: tan x = 1 for 0°≤x≤180°",
  options: ["45°", "45°,225°", "90°", "135°"],
  answer: "45°"
},
{
  question: "Solve: sin x = cos x for 0°≤x≤180°",
  options: ["45°", "135°", "90°", "0°"],
  answer: "45°"
},
{
  question: "Period of sin x graph:",
  options: ["360°", "180°", "90°", "720°"],
  answer: "360°"
},
{
  question: "Period of sin2x:",
  options: ["180°", "360°", "90°", "720°"],
  answer: "180°"
},
{
  question: "Amplitude of y=2sin x:",
  options: ["2", "1", "4", "3"],
  answer: "2"
},
{
  question: "Amplitude of y=3cos x:",
  options: ["3", "1", "2", "4"],
  answer: "3"
},
{
  question: "Range of y=sin x:",
  options: ["−1 to 1", "0 to 1", "−2 to 2", "0 to 2"],
  answer: "−1 to 1"
},
{
  question: "Range of y=2cos x:",
  options: ["−2 to 2", "−1 to 1", "0 to 2", "−3 to 3"],
  answer: "−2 to 2"
},
{
  question: "y=sin x shifted up by 2:",
  options: ["y=sin x+2", "y=2sin x", "y=sin(x+2)", "y=sin2x"],
  answer: "y=sin x+2"
},
{
  question: "y=cos x shifted right by 90°:",
  options: ["y=cos(x−90°)", "y=cos(x+90°)", "y=cos2x", "y=2cos x"],
  answer: "y=cos(x−90°)"
},
{
  question: "Maximum value of sin x:",
  options: ["1", "0", "−1", "2"],
  answer: "1"
},
{
  question: "Minimum value of cos x:",
  options: ["−1", "1", "0", "2"],
  answer: "−1"
},
{
  question: "Solve: sin x = 0.707",
  options: ["45°,135°", "30°,150°", "60°,120°", "90°"],
  answer: "45°,135°"
},
{
  question: "Solve: cos x = 0.5",
  options: ["60°,300°", "30°,150°", "45°,135°", "90°,270°"],
  answer: "60°,300°"
},
{
  question: "Solve: tan x = −1",
  options: ["135°,315°", "45°,225°", "30°,150°", "60°,240°"],
  answer: "135°,315°"
},
{
  question: "Solve: 2sin²x = 1",
  options: ["45°,135°,225°,315°", "30°,150°", "60°,120°", "0°,180°"],
  answer: "45°,135°,225°,315°"
},
{
  question: "Solve: 1 − cos²x = 0",
  options: ["0°,180°,360°", "90°,270°", "45°,135°", "30°,150°"],
  answer: "0°,180°,360°"
},
{
  question: "Solve: sec²x = 2",
  options: ["45°,135°,225°,315°", "30°,150°", "60°,120°", "0°,180°"],
  answer: "45°,135°,225°,315°"
},
{
  question: "Solve: tan²x = 3",
  options: ["60°,120°,240°,300°", "30°,150°", "45°,135°", "0°,180°"],
  answer: "60°,120°,240°,300°"
},

{
  question: "Differentiate: x²",
  options: ["2x", "x", "x²", "2"],
  answer: "2x"
},
{
  question: "Differentiate: x³",
  options: ["3x²", "x²", "x³", "3x"],
  answer: "3x²"
},
{
  question: "Differentiate: 5x",
  options: ["5", "x", "5x", "0"],
  answer: "5"
},
{
  question: "Differentiate: 7",
  options: ["0", "7", "1", "x"],
  answer: "0"
},
{
  question: "Differentiate: 3x² + 4x",
  options: ["6x + 4", "3x + 4", "6x", "4x"],
  answer: "6x + 4"
},
{
  question: "Differentiate: x³ + 2x²",
  options: ["3x² + 4x", "3x² + 2x", "x² + 4x", "3x²"],
  answer: "3x² + 4x"
},
{
  question: "Differentiate: 4x³ − 2x",
  options: ["12x² − 2", "4x² − 2", "12x² − 2x", "4x³"],
  answer: "12x² − 2"
},
{
  question: "Differentiate: x⁴",
  options: ["4x³", "x³", "x⁴", "4x"],
  answer: "4x³"
},
{
  question: "Differentiate: 2x⁵",
  options: ["10x⁴", "5x⁴", "2x⁴", "10x"],
  answer: "10x⁴"
},
{
  question: "Differentiate: x² + 3",
  options: ["2x", "2x + 3", "x", "3"],
  answer: "2x"
},
{
  question: "Differentiate: (x²)(x³)",
  options: ["5x⁴", "x⁵", "4x⁴", "3x⁴"],
  answer: "5x⁴"
},
{
  question: "Differentiate: sin x",
  options: ["cos x", "−cos x", "sin x", "−sin x"],
  answer: "cos x"
},
{
  question: "Differentiate: cos x",
  options: ["−sin x", "sin x", "cos x", "−cos x"],
  answer: "−sin x"
},
{
  question: "Differentiate: 2sin x",
  options: ["2cos x", "cos x", "2sin x", "−2cos x"],
  answer: "2cos x"
},
{
  question: "Differentiate: 3cos x",
  options: ["−3sin x", "3sin x", "−cos x", "3cos x"],
  answer: "−3sin x"
},
{
  question: "Differentiate: x² sin x",
  options: ["2x sin x + x² cos x", "x² cos x", "2x cos x", "sin x"],
  answer: "2x sin x + x² cos x"
},
{
  question: "Find gradient of y=x² at x=2",
  options: ["4", "2", "6", "8"],
  answer: "4"
},
{
  question: "Find gradient of y=3x² at x=1",
  options: ["6", "3", "9", "2"],
  answer: "6"
},
{
  question: "Find gradient of y=x³ at x=2",
  options: ["12", "8", "6", "4"],
  answer: "12"
},
{
  question: "Equation of tangent to y=x² at x=1",
  options: ["y=2x−1", "y=x−1", "y=2x+1", "y=x+1"],
  answer: "y=2x−1"
},
{
  question: "Equation of tangent to y=x² at x=2",
  options: ["y=4x−4", "y=2x−2", "y=4x−8", "y=2x−4"],
  answer: "y=4x−4"
},
{
  question: "Find stationary point of y=x²",
  options: ["(0,0)", "(1,1)", "(2,4)", "(−1,1)"],
  answer: "(0,0)"
},
{
  question: "Find stationary point of y=x³",
  options: ["(0,0)", "(1,1)", "(−1,−1)", "(2,8)"],
  answer: "(0,0)"
},
{
  question: "If dy/dx = 0, point is:",
  options: ["stationary", "increasing", "decreasing", "undefined"],
  answer: "stationary"
},
{
  question: "Differentiate: (2x+1)²",
  options: ["4(2x+1)", "2(2x+1)", "4x+2", "2x+1"],
  answer: "4(2x+1)"
},
{
  question: "Differentiate: (x²+1)²",
  options: ["4x(x²+1)", "2x(x²+1)", "2(x²+1)", "x²+1"],
  answer: "4x(x²+1)"
},
{
  question: "Find gradient of y=sin x at x=0",
  options: ["1", "0", "−1", "2"],
  answer: "1"
},
{
  question: "Find gradient of y=cos x at x=0",
  options: ["0", "1", "−1", "2"],
  answer: "0"
},
{
  question: "Differentiate: x⁻¹",
  options: ["−x⁻²", "x⁻²", "−1/x", "1/x"],
  answer: "−x⁻²"
},
{
  question: "Differentiate: x^(1/2)",
  options: ["1/(2√x)", "√x", "1/x", "2√x"],
  answer: "1/(2√x)"
},

{
  question: "Find stationary point of y = x² − 4x + 3",
  options: ["(2,−1)", "(1,0)", "(2,1)", "(−2,3)"],
  answer: "(2,−1)"
},
{
  question: "Nature of y = x² − 4x + 3",
  options: ["minimum", "maximum", "inflection", "none"],
  answer: "minimum"
},
{
  question: "Find stationary point of y = −x² + 4x",
  options: ["(2,4)", "(−2,4)", "(2,−4)", "(1,2)"],
  answer: "(2,4)"
},
{
  question: "Nature of y = −x² + 4x",
  options: ["maximum", "minimum", "inflection", "none"],
  answer: "maximum"
},
{
  question: "Find stationary point of y = x³ − 3x²",
  options: ["(0,0),(2,−4)", "(0,0),(2,0)", "(1,−2),(2,0)", "(0,1),(2,4)"],
  answer: "(0,0),(2,−4)"
},
{
  question: "Solve dy/dx = 0 for y = x³ − 3x²",
  options: ["x=0,2", "x=1,2", "x=0,1", "x=2,3"],
  answer: "x=0,2"
},
{
  question: "Find max of y = −x² + 6x − 5",
  options: ["4", "5", "6", "3"],
  answer: "4"
},
{
  question: "Find x at maximum for y = −x² + 6x − 5",
  options: ["3", "2", "4", "1"],
  answer: "3"
},
{
  question: "Find minimum of y = x² + 2x + 1",
  options: ["0", "1", "−1", "2"],
  answer: "0"
},
{
  question: "Find x at minimum of y = x² + 2x + 1",
  options: ["−1", "1", "2", "0"],
  answer: "−1"
},
{
  question: "If dy/dx > 0, function is:",
  options: ["increasing", "decreasing", "constant", "stationary"],
  answer: "increasing"
},
{
  question: "If dy/dx < 0, function is:",
  options: ["decreasing", "increasing", "constant", "stationary"],
  answer: "decreasing"
},
{
  question: "Turning point occurs when:",
  options: ["dy/dx = 0", "dy/dx > 0", "dy/dx < 0", "dy/dx undefined"],
  answer: "dy/dx = 0"
},
{
  question: "Find stationary point of y = x² + 4x + 5",
  options: ["(−2,1)", "(2,1)", "(−2,−1)", "(2,−1)"],
  answer: "(−2,1)"
},
{
  question: "Nature of y = x² + 4x + 5",
  options: ["minimum", "maximum", "inflection", "none"],
  answer: "minimum"
},
{
  question: "Find turning point of y = 2x² − 8x + 3",
  options: ["(2,−5)", "(2,5)", "(−2,5)", "(4,3)"],
  answer: "(2,−5)"
},
{
  question: "Nature of y = 2x² − 8x + 3",
  options: ["minimum", "maximum", "inflection", "none"],
  answer: "minimum"
},
{
  question: "Find stationary point of y = −2x² + 4x + 1",
  options: ["(1,3)", "(−1,3)", "(2,1)", "(1,−3)"],
  answer: "(1,3)"
},
{
  question: "Nature of y = −2x² + 4x + 1",
  options: ["maximum", "minimum", "inflection", "none"],
  answer: "maximum"
},
{
  question: "If y = x³, stationary point is:",
  options: ["(0,0)", "(1,1)", "(−1,−1)", "(2,8)"],
  answer: "(0,0)"
},
{
  question: "Nature of y = x³ at (0,0)",
  options: ["inflection", "maximum", "minimum", "none"],
  answer: "inflection"
},
{
  question: "Maximum occurs when second derivative is:",
  options: ["negative", "positive", "zero", "undefined"],
  answer: "negative"
},
{
  question: "Minimum occurs when second derivative is:",
  options: ["positive", "negative", "zero", "undefined"],
  answer: "positive"
},
{
  question: "Find dy/dx of y = x² − 6x + 8 at x=3",
  options: ["0", "3", "6", "−3"],
  answer: "0"
},
{
  question: "If dy/dx changes from + to −, point is:",
  options: ["maximum", "minimum", "inflection", "none"],
  answer: "maximum"
},
{
  question: "If dy/dx changes from − to +, point is:",
  options: ["minimum", "maximum", "inflection", "none"],
  answer: "minimum"
},
{
  question: "Find maximum value of y = −x² + 2x + 3",
  options: ["4", "3", "2", "5"],
  answer: "4"
},
{
  question: "Find x at max of y = −x² + 2x + 3",
  options: ["1", "2", "−1", "0"],
  answer: "1"
},
{
  question: "Find minimum value of y = x² − 2x + 4",
  options: ["3", "4", "2", "1"],
  answer: "3"
},
{
  question: "Find x at minimum of y = x² − 2x + 4",
  options: ["1", "2", "−1", "0"],
  answer: "1"
},

{
  question: "Integrate: ∫x dx",
  options: ["x²/2 + C", "x² + C", "2x + C", "x + C"],
  answer: "x²/2 + C"
},
{
  question: "Integrate: ∫x² dx",
  options: ["x³/3 + C", "x³ + C", "2x² + C", "x²/2 + C"],
  answer: "x³/3 + C"
},
{
  question: "Integrate: ∫3x² dx",
  options: ["x³ + C", "3x³ + C", "x² + C", "6x + C"],
  answer: "x³ + C"
},
{
  question: "Integrate: ∫5 dx",
  options: ["5x + C", "x + C", "5 + C", "x² + C"],
  answer: "5x + C"
},
{
  question: "Integrate: ∫2x dx",
  options: ["x² + C", "2x² + C", "x + C", "2 + C"],
  answer: "x² + C"
},
{
  question: "Integrate: ∫x³ dx",
  options: ["x⁴/4 + C", "x⁴ + C", "4x³ + C", "x³/3 + C"],
  answer: "x⁴/4 + C"
},
{
  question: "Integrate: ∫x⁻¹ dx",
  options: ["ln x + C", "x² + C", "1/x + C", "x + C"],
  answer: "ln x + C"
},
{
  question: "Integrate: ∫1/x dx",
  options: ["ln x + C", "x² + C", "1/x + C", "x + C"],
  answer: "ln x + C"
},
{
  question: "Integrate: ∫(2x + 3) dx",
  options: ["x² + 3x + C", "2x² + 3x + C", "x² + C", "2x + C"],
  answer: "x² + 3x + C"
},
{
  question: "Integrate: ∫(4x³ − 2x) dx",
  options: ["x⁴ − x² + C", "4x⁴ − 2x² + C", "x⁴ − x + C", "x³ + C"],
  answer: "x⁴ − x² + C"
},
{
  question: "Integrate: ∫sin x dx",
  options: ["−cos x + C", "cos x + C", "sin x + C", "−sin x + C"],
  answer: "−cos x + C"
},
{
  question: "Integrate: ∫cos x dx",
  options: ["sin x + C", "−sin x + C", "cos x + C", "−cos x + C"],
  answer: "sin x + C"
},
{
  question: "Integrate: ∫2sin x dx",
  options: ["−2cos x + C", "2cos x + C", "−cos x + C", "sin x + C"],
  answer: "−2cos x + C"
},
{
  question: "Integrate: ∫3cos x dx",
  options: ["3sin x + C", "−3sin x + C", "sin x + C", "cos x + C"],
  answer: "3sin x + C"
},
{
  question: "Find ∫(x + 1)² dx",
  options: ["(x+1)³/3 + C", "(x+1)² + C", "2(x+1) + C", "x² + C"],
  answer: "(x+1)³/3 + C"
},
{
  question: "Find ∫(2x + 1) dx",
  options: ["x² + x + C", "2x² + x + C", "x² + C", "2x + C"],
  answer: "x² + x + C"
},
{
  question: "Find ∫x⁴ dx",
  options: ["x⁵/5 + C", "x⁵ + C", "5x⁴ + C", "x⁴/4 + C"],
  answer: "x⁵/5 + C"
},
{
  question: "Find ∫x⁻² dx",
  options: ["−x⁻¹ + C", "x⁻¹ + C", "−1/x² + C", "1/x + C"],
  answer: "−x⁻¹ + C"
},
{
  question: "Find ∫(3x² + 2x + 1) dx",
  options: ["x³ + x² + x + C", "3x³ + 2x² + x + C", "x² + x + C", "x³ + C"],
  answer: "x³ + x² + x + C"
},
{
  question: "Find ∫(x³ + 4x) dx",
  options: ["x⁴/4 + 2x² + C", "x⁴ + 4x² + C", "x³ + 4x + C", "x² + C"],
  answer: "x⁴/4 + 2x² + C"
},
{
  question: "Evaluate: ∫₀² x dx",
  options: ["2", "4", "1", "3"],
  answer: "2"
},
{
  question: "Evaluate: ∫₀¹ x² dx",
  options: ["1/3", "1/2", "1", "2"],
  answer: "1/3"
},
{
  question: "Evaluate: ∫₀² 2x dx",
  options: ["4", "2", "6", "8"],
  answer: "4"
},
{
  question: "Evaluate: ∫₁² x dx",
  options: ["3/2", "2", "1", "4"],
  answer: "3/2"
},
{
  question: "Evaluate: ∫₀π sin x dx",
  options: ["2", "1", "0", "π"],
  answer: "2"
},
{
  question: "Evaluate: ∫₀π cos x dx",
  options: ["0", "1", "2", "π"],
  answer: "0"
},
{
  question: "Find area under y=x from 0 to 2",
  options: ["2", "4", "1", "3"],
  answer: "2"
},
{
  question: "Find area under y=x² from 0 to 1",
  options: ["1/3", "1/2", "1", "2"],
  answer: "1/3"
},
{
  question: "Find ∫(2x+1) from 0 to 2",
  options: ["6", "5", "4", "3"],
  answer: "6"
},
{
  question: "If ∫f(x)dx = x² + C, then f(x)=",
  options: ["2x", "x", "x²", "1"],
  answer: "2x"
},

{
  question: "Find area under y = x from 0 to 4",
  options: ["8", "16", "4", "12"],
  answer: "8"
},
{
  question: "Find area under y = x² from 0 to 2",
  options: ["8/3", "4", "2", "16/3"],
  answer: "8/3"
},
{
  question: "Find area under y = 2x from 0 to 3",
  options: ["9", "6", "3", "12"],
  answer: "9"
},
{
  question: "Find area under y = 3x² from 0 to 2",
  options: ["8", "4", "6", "12"],
  answer: "8"
},
{
  question: "Find area under y = x + 1 from 0 to 2",
  options: ["4", "3", "2", "5"],
  answer: "4"
},
{
  question: "Find area under y = x² + 1 from 0 to 1",
  options: ["4/3", "1", "2", "3/2"],
  answer: "4/3"
},
{
  question: "Find area under y = 4x − x² from 0 to 4",
  options: ["32/3", "16", "8", "24"],
  answer: "32/3"
},
{
  question: "Find area between y = x and x-axis from 0 to 3",
  options: ["9/2", "9", "6", "3"],
  answer: "9/2"
},
{
  question: "Find area between y = x² and x-axis from 0 to 3",
  options: ["9", "27", "3", "6"],
  answer: "9"
},
{
  question: "Find area between y = x and y = 0 from 1 to 3",
  options: ["4", "3", "2", "6"],
  answer: "4"
},
{
  question: "Find area between y = x² and y = x from 0 to 1",
  options: ["1/6", "1/2", "1/3", "1/4"],
  answer: "1/6"
},
{
  question: "Find area between y = x² and y = x from 0 to 2",
  options: ["2/3", "4/3", "2", "1"],
  answer: "2/3"
},
{
  question: "Find area between y = 2x and y = x² from 0 to 2",
  options: ["4/3", "2", "3", "1"],
  answer: "4/3"
},
{
  question: "Find area between y = x² and y = 4 from 0 to 2",
  options: ["16/3", "8", "4", "12"],
  answer: "16/3"
},
{
  question: "Find area between y = 4 − x² and x-axis from −2 to 2",
  options: ["16/3", "8", "4", "12"],
  answer: "16/3"
},
{
  question: "Find ∫₀² (x² + x) dx",
  options: ["14/3", "6", "8/3", "4"],
  answer: "14/3"
},
{
  question: "Find ∫₀³ (x + 2) dx",
  options: ["15/2", "6", "12", "9"],
  answer: "15/2"
},
{
  question: "Find ∫₁² (2x) dx",
  options: ["3", "4", "2", "5"],
  answer: "3"
},
{
  question: "Find ∫₀¹ (3x² + 2) dx",
  options: ["3", "2", "1", "4"],
  answer: "3"
},
{
  question: "Find ∫₀² (x³ − x) dx",
  options: ["2", "4", "1", "3"],
  answer: "2"
},
{
  question: "Find ∫₀π (sin x + cos x) dx",
  options: ["2", "1", "0", "π"],
  answer: "2"
},
{
  question: "Find ∫₀π sin x dx",
  options: ["2", "1", "0", "π"],
  answer: "2"
},
{
  question: "Find ∫₀π cos x dx",
  options: ["0", "1", "2", "π"],
  answer: "0"
},
{
  question: "Find area under y = x² from 1 to 2",
  options: ["7/3", "8/3", "5/3", "2"],
  answer: "7/3"
},
{
  question: "Find area under y = 2x + 1 from 1 to 3",
  options: ["10", "8", "6", "12"],
  answer: "10"
},
{
  question: "Find area between y = x² and y = 2x from 0 to 2",
  options: ["4/3", "2", "1", "3"],
  answer: "4/3"
},
{
  question: "Find area under y = 1/x from 1 to e",
  options: ["1", "e", "ln e", "0"],
  answer: "1"
},
{
  question: "Find ∫₀¹ x⁴ dx",
  options: ["1/5", "1/4", "1/3", "1/2"],
  answer: "1/5"
},
{
  question: "Find ∫₀² x² dx",
  options: ["8/3", "4", "2", "16/3"],
  answer: "8/3"
},
{
  question: "Find ∫₀³ x dx",
  options: ["9/2", "9", "6", "3"],
  answer: "9/2"
},

{
  question: "Find magnitude of vector (3,4)",
  options: ["5", "7", "4", "6"],
  answer: "5"
},
{
  question: "Find magnitude of vector (5,12)",
  options: ["13", "17", "12", "25"],
  answer: "13"
},
{
  question: "Find magnitude of (1,1)",
  options: ["√2", "2", "1", "√3"],
  answer: "√2"
},
{
  question: "Find magnitude of (6,8)",
  options: ["10", "12", "14", "8"],
  answer: "10"
},
{
  question: "Find vector AB if A(1,2), B(4,6)",
  options: ["(3,4)", "(−3,−4)", "(5,8)", "(2,4)"],
  answer: "(3,4)"
},
{
  question: "Find vector AB if A(2,3), B(5,7)",
  options: ["(3,4)", "(5,7)", "(−3,−4)", "(2,4)"],
  answer: "(3,4)"
},
{
  question: "Find midpoint of A(2,4), B(6,8)",
  options: ["(4,6)", "(2,6)", "(6,4)", "(3,5)"],
  answer: "(4,6)"
},
{
  question: "Find vector sum (1,2) + (3,4)",
  options: ["(4,6)", "(3,6)", "(4,5)", "(2,4)"],
  answer: "(4,6)"
},
{
  question: "Find (2,3) − (1,1)",
  options: ["(1,2)", "(3,4)", "(1,1)", "(2,2)"],
  answer: "(1,2)"
},
{
  question: "Find 2(3,4)",
  options: ["(6,8)", "(3,8)", "(6,4)", "(2,4)"],
  answer: "(6,8)"
},
{
  question: "Find −(2,3)",
  options: ["(−2,−3)", "(2,3)", "(−3,−2)", "(3,2)"],
  answer: "(−2,−3)"
},
{
  question: "Find dot product (1,2)·(3,4)",
  options: ["11", "10", "12", "8"],
  answer: "11"
},
{
  question: "Find dot product (2,3)·(4,5)",
  options: ["23", "20", "25", "18"],
  answer: "23"
},
{
  question: "If a·b = 0, vectors are:",
  options: ["perpendicular", "parallel", "equal", "zero"],
  answer: "perpendicular"
},
{
  question: "Find angle between (1,0) and (0,1)",
  options: ["90°", "0°", "45°", "180°"],
  answer: "90°"
},
{
  question: "Find unit vector of (3,4)",
  options: ["(3/5,4/5)", "(4/5,3/5)", "(5,5)", "(1,1)"],
  answer: "(3/5,4/5)"
},
{
  question: "Find magnitude of unit vector",
  options: ["1", "0", "2", "√2"],
  answer: "1"
},
{
  question: "Find scalar k if k(2,3)=(4,6)",
  options: ["2", "3", "1", "4"],
  answer: "2"
},
{
  question: "Find vector parallel to (2,3)",
  options: ["(4,6)", "(3,2)", "(1,1)", "(2,4)"],
  answer: "(4,6)"
},
{
  question: "Find vector perpendicular to (1,0)",
  options: ["(0,1)", "(1,1)", "(2,0)", "(1,0)"],
  answer: "(0,1)"
},
{
  question: "Find magnitude of (0,5)",
  options: ["5", "0", "10", "2"],
  answer: "5"
},
{
  question: "Find (1,2)+(−1,−2)",
  options: ["(0,0)", "(2,4)", "(−2,−4)", "(1,1)"],
  answer: "(0,0)"
},
{
  question: "If |a|=5, |b|=4, and a·b=20, angle:",
  options: ["0°", "90°", "45°", "60°"],
  answer: "0°"
},
{
  question: "If |a|=3, |b|=4, and a·b=0, angle:",
  options: ["90°", "0°", "45°", "180°"],
  answer: "90°"
},
{
  question: "Find projection of (3,4) on (1,0)",
  options: ["3", "4", "5", "2"],
  answer: "3"
},
{
  question: "Find magnitude of (2,−2)",
  options: ["2√2", "4", "√2", "2"],
  answer: "2√2"
},
{
  question: "Find vector from (0,0) to (5,5)",
  options: ["(5,5)", "(0,0)", "(−5,−5)", "(5,0)"],
  answer: "(5,5)"
},
{
  question: "Find 3(1,−2)",
  options: ["(3,−6)", "(1,−6)", "(3,−2)", "(−3,6)"],
  answer: "(3,−6)"
},
{
  question: "Find dot product (0,1)·(1,0)",
  options: ["0", "1", "2", "−1"],
  answer: "0"
},
{
  question: "If vectors are parallel, dot product is:",
  options: ["maximum", "zero", "negative", "undefined"],
  answer: "maximum"
},

{
  question: "Find mean of 2,4,6,8",
  options: ["5", "6", "4", "8"],
  answer: "5"
},
{
  question: "Find mean of 1,3,5,7,9",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "Find median of 2,4,6,8,10",
  options: ["6", "5", "4", "8"],
  answer: "6"
},
{
  question: "Find range of 2,5,8,10",
  options: ["8", "10", "6", "5"],
  answer: "8"
},
{
  question: "Find variance of 1,1,1,1",
  options: ["0", "1", "2", "4"],
  answer: "0"
},
{
  question: "Find probability of head in one coin toss",
  options: ["1/2", "1", "0", "2"],
  answer: "1/2"
},
{
  question: "Find probability of 3 in fair die",
  options: ["1/6", "1/3", "1/2", "1"],
  answer: "1/6"
},
{
  question: "Find probability of even number in die",
  options: ["1/2", "1/3", "2/3", "1"],
  answer: "1/2"
},
{
  question: "Find probability of getting tail",
  options: ["1/2", "1", "0", "2"],
  answer: "1/2"
},
{
  question: "Total outcomes of two coins",
  options: ["4", "2", "3", "6"],
  answer: "4"
},
{
  question: "Probability of two heads (2 coins)",
  options: ["1/4", "1/2", "1/3", "1"],
  answer: "1/4"
},
{
  question: "Probability of at least one head (2 coins)",
  options: ["3/4", "1/4", "1/2", "1"],
  answer: "3/4"
},
{
  question: "Total outcomes of two dice",
  options: ["36", "12", "6", "24"],
  answer: "36"
},
{
  question: "Probability sum = 7 (two dice)",
  options: ["1/6", "1/12", "1/36", "2/6"],
  answer: "1/6"
},
{
  question: "Probability of getting 1 on die",
  options: ["1/6", "1/3", "1/2", "1"],
  answer: "1/6"
},

{
  question: "Find variance of constant data",
  options: ["0", "1", "2", "3"],
  answer: "0"
},
{
  question: "Find probability of impossible event",
  options: ["0", "1", "1/2", "2"],
  answer: "0"
},
{
  question: "Find probability of certain event",
  options: ["1", "0", "1/2", "2"],
  answer: "1"
},
{
  question: "Probability lies between:",
  options: ["0 and 1", "1 and 2", "−1 and 1", "0 and 2"],
  answer: "0 and 1"
},

{
  question: "Find median of 1,2,3,4,5",
  options: ["3", "2", "4", "5"],
  answer: "3"
},
{
  question: "Find probability of odd number (die)",
  options: ["1/2", "1/3", "2/3", "1"],
  answer: "1/2"
},
{
  question: "Find probability of getting 2 heads (3 coins)",
  options: ["3/8", "1/4", "1/2", "1/8"],
  answer: "3/8"
},
{
  question: "Find total outcomes of 3 coins",
  options: ["8", "6", "4", "12"],
  answer: "8"
},
{
  question: "Find mean of 10,20,30,40",
  options: ["25", "20", "30", "40"],
  answer: "25"
},
{
  question: "Find range of 5,10,15",
  options: ["10", "15", "5", "20"],
  answer: "10"
},
{
  question: "Find probability of red card (52 cards)",
  options: ["1/2", "1/4", "1/13", "1"],
  answer: "1/2"
},

{
  question: "Add matrices [[1,2],[3,4]] + [[2,1],[0,1]]",
  options: ["[[3,3],[3,5]]", "[[2,3],[3,4]]", "[[1,1],[3,5]]", "[[3,2],[3,5]]"],
  answer: "[[3,3],[3,5]]"
},
{
  question: "Multiply [[1,2],[3,4]] × [[1,0],[0,1]]",
  options: ["same matrix", "zero matrix", "identity", "transpose"],
  answer: "same matrix"
},
{
  question: "Find determinant of [[2,3],[1,4]]",
  options: ["5", "11", "8", "7"],
  answer: "5"
},
{
  question: "Find determinant of [[3,1],[2,2]]",
  options: ["4", "5", "6", "3"],
  answer: "4"
},
{
  question: "Find inverse determinant condition:",
  options: ["det ≠ 0", "det = 0", "det = 1", "det > 1"],
  answer: "det ≠ 0"
},
{
  question: "Solve using matrix: x+y=5, x−y=1",
  options: ["x=3,y=2", "x=2,y=3", "x=4,y=1", "x=1,y=4"],
  answer: "x=3,y=2"
},
{
  question: "Reflection in x-axis changes (x,y) to:",
  options: ["(x,−y)", "(−x,y)", "(y,x)", "(−x,−y)"],
  answer: "(x,−y)"
},
{
  question: "Reflection in y-axis:",
  options: ["(−x,y)", "(x,−y)", "(y,x)", "(−x,−y)"],
  answer: "(−x,y)"
},
{
  question: "Translation by (2,3) moves (1,1) to:",
  options: ["(3,4)", "(2,3)", "(1,4)", "(4,3)"],
  answer: "(3,4)"
},
{
  question: "Rotation 90° anticlockwise:",
  options: ["(−y,x)", "(y,−x)", "(x,y)", "(−x,−y)"],
  answer: "(−y,x)"
},
{
  question: "If p=true, q=false, p∧q:",
  options: ["false", "true", "undefined", "none"],
  answer: "false"
},
{
  question: "If p=true, q=false, p∨q:",
  options: ["true", "false", "undefined", "none"],
  answer: "true"
},
{
  question: "If p→q when p=true q=false:",
  options: ["false", "true", "undefined", "none"],
  answer: "false"
},
{
  question: "Convert 180° to radians",
  options: ["π", "2π", "π/2", "π/4"],
  answer: "π"
},
{
  question: "Convert 90° to radians",
  options: ["π/2", "π", "2π", "π/4"],
  answer: "π/2"
},
{
  question: "Arc length formula:",
  options: ["rθ", "θ/r", "r/θ", "θ²"],
  answer: "rθ"
},
{
  question: "Area sector formula:",
  options: ["1/2 r²θ", "rθ", "θ²", "2rθ"],
  answer: "1/2 r²θ"
},
{
  question: "Use sine rule: a/sinA =",
  options: ["b/sinB", "bcosB", "b+sinB", "b−sinB"],
  answer: "b/sinB"
},
{
  question: "If a=5, b=7, C=60°, find c (cosine rule approx)",
  options: ["~6", "~8", "~10", "~4"],
  answer: "~6"
},
{
  question: "Mean of grouped data uses:",
  options: ["midpoint", "raw data", "sum only", "range"],
  answer: "midpoint"
},
{
  question: "Standard deviation measures:",
  options: ["spread", "mean", "median", "mode"],
  answer: "spread"
},
{
  question: "If speed=distance/time, find speed for 100m in 10s",
  options: ["10 m/s", "5 m/s", "20 m/s", "100 m/s"],
  answer: "10 m/s"
},
{
  question: "Acceleration =",
  options: ["change in velocity/time", "distance/time", "force/mass", "velocity"],
  answer: "change in velocity/time"
},
{
  question: "Force =",
  options: ["mass × acceleration", "mass/time", "velocity/time", "distance/time"],
  answer: "mass × acceleration"
},
{
  question: "If v=20 m/s, t=5s, acceleration:",
  options: ["4 m/s²", "5 m/s²", "2 m/s²", "10 m/s²"],
  answer: "4 m/s²"
},
{
  question: "Find det [[1,2],[3,5]]",
  options: ["−1", "1", "5", "7"],
  answer: "−1"
},
{
  question: "Inverse exists when determinant:",
  options: ["≠0", "=0", ">1", "<1"],
  answer: "≠0"
},
{
  question: "Find translation (x+3,y−2) of (1,1)",
  options: ["(4,−1)", "(3,−1)", "(1,−2)", "(4,1)"],
  answer: "(4,−1)"
},
{
  question: "If P(A)=0.5, P(A')=",
  options: ["0.5", "1", "0", "0.25"],
  answer: "0.5"
},
{
  question: "If events are independent, P(A∩B)=",
  options: ["P(A)P(B)", "P(A)+P(B)", "P(A−B)", "0"],
  answer: "P(A)P(B)"
},

{
  question: "The diagram shows a Venn diagram of sets A, B, and C. Which region represents A âˆ© B âˆ© C?",
  image: "/images/addmath1.png",
  options: ["Common intersection", "A only", "B only", "Outside region"],
  answer: "Common intersection"
},

{
  question: "The diagram shows a Venn diagram. Which law is illustrated by (A âˆª B)' = A' âˆ© B'?",
  image: "/images/addmath2.png",
  options: ["De Morganâ€™s law", "Associative law", "Commutative law", "Distributive law"],
  answer: "De Morganâ€™s law"
},


{
  question: "The diagram shows a function graph. What is the domain?",
  image: "/images/addmath5.png",
  options: ["All x values", "All y values", "Positive only", "Negative only"],
  answer: "All x values"
},

{
  question: "The diagram shows a quadratic graph. What is the axis of symmetry?",
  image: "/images/addmath9.png",
  options: ["x = -b/2a", "y = mx + c", "x = 0", "y = 0"],
  answer: "x = -b/2a"
},

{
  question: "The diagram shows a cubic function. What is the degree of the polynomial?",
  image: "/images/addmath10.png",
  options: ["3", "2", "1", "4"],
  answer: "3"
},

{
  question: "The diagram shows a cubic graph. How many real roots does the function have?",
  image: "/images/addmath11.png",
  options: ["3", "2", "1", "0"],
  answer: "3"
},


{
  question: "Using the remainder theorem, find the remainder when f(x)=2xÂ³+3xÂ²-5 is divided by (x-1).",
  image: "/images/addmath13.png",
  options: ["0", "5", "2", "-1"],
  answer: "0"
},

{
  question: "The diagram shows a polynomial graph. What is the turning point?",
  image: "/images/addmath14.png",
  options: ["Maximum or minimum point", "Intercept", "Root", "Gradient"],
  answer: "Maximum or minimum point"
},



{
  question: "The diagram shows a rational function. Where is the function undefined?",
  image: "/images/addmath16.png",
  options: ["Denominator = 0", "Numerator = 0", "x = 0", "y = 0"],
  answer: "Denominator = 0"
},

{
  question: "The diagram shows asymptotes of a rational function. What is a vertical asymptote?",
  image: "/images/addmath17.png",
  options: ["x = constant", "y = constant", "Origin", "Curve"],
  answer: "x = constant"
},

{
  question: "The diagram shows linear inequalities. What region represents the solution?",
  image: "/images/addmath18.png",
  options: ["Shaded region", "Line only", "Points only", "Outside region"],
  answer: "Shaded region"
},

{
  question: "The diagram shows feasible region in linear programming. What determines the optimal solution?",
  image: "/images/addmath19.png",
  options: ["Corner points", "Edges", "Centre", "Any point"],
  answer: "Corner points"
},

{
  question: "The diagram shows simultaneous inequalities. What is the solution set?",
  image: "/images/addmath20.png",
  options: ["Intersection region", "Union", "Separate regions", "Lines"],
  answer: "Intersection region"
},

{
  question: "The diagram shows a right-angled triangle. What is sin Î¸?",
  image: "/images/addmath21.png",
  options: ["Opp/Hyp", "Adj/Hyp", "Opp/Adj", "Hyp/Adj"],
  answer: "Opp/Hyp"
},

{
  question: "The diagram shows a triangle. Which ratio represents cos Î¸?",
  image: "/images/addmath22.png",
  options: ["Adj/Hyp", "Opp/Hyp", "Opp/Adj", "Hyp/Opp"],
  answer: "Adj/Hyp"
},

{
  question: "The diagram shows a unit circle. What is the value of sin 90Â°?",
  image: "/images/addmath23.png",
  options: ["1", "0", "-1", "1/2"],
  answer: "1"
},

{
  question: "The diagram shows a unit circle. What is cos 0Â°?",
  image: "/images/addmath24.png",
  options: ["1", "0", "-1", "1/2"],
  answer: "1"
},

{
  question: "The diagram shows sin x graph. What is the amplitude?",
  image: "/images/addmath25.png",
  options: ["1", "2", "0", "Ï€"],
  answer: "1"
},

{
  question: "The diagram shows tan x graph. Where are the asymptotes located?",
  image: "/images/addmath26.png",
  options: ["x = 90Â° + n180Â°", "x = 0", "x = 180Â°", "x = 360Â°"],
  answer: "x = 90Â° + n180Â°"
},

{
  question: "The diagram shows triangle ABC. Which rule is applied?",
  image: "/images/addmath27.png",
  options: ["Sine rule", "Cosine rule", "Pythagoras", "Identity"],
  answer: "Sine rule"
},

{
  question: "The diagram shows triangle with 3 sides known. Which rule is used?",
  image: "/images/addmath28.png",
  options: ["Cosine rule", "Sine rule", "Tan rule", "Identity"],
  answer: "Cosine rule"
},

{
  question: "The diagram shows angle sum. What identity is used?",
  image: "/images/addmath29.png",
  options: ["sin(A+B)", "cos(A+B)", "tan(A+B)", "All"],
  answer: "sin(A+B)"
},

{
  question: "The diagram shows graph of y = cos x. What is the period?",
  image: "/images/addmath30.png",
  options: ["360Â°", "180Â°", "90Â°", "720Â°"],
  answer: "360Â°"
},

{
  question: "The diagram shows a curve with a tangent at point P. What does the gradient represent?",
  image: "/images/addmath31.png",
  options: ["Rate of change", "Area", "Distance", "Intercept"],
  answer: "Rate of change"
},

{
  question: "The diagram shows a curve. At which point is the gradient zero?",
  image: "/images/addmath32.png",
  options: ["Turning point", "Intercept", "End point", "Any point"],
  answer: "Turning point"
},

{
  question: "The diagram shows a maximum point on a curve. What is true at this point?",
  image: "/images/addmath33.png",
  options: ["Gradient = 0", "Gradient > 0", "Gradient < 0", "Undefined"],
  answer: "Gradient = 0"
},

{
  question: "The diagram shows a minimum point. What is true about the curve?",
  image: "/images/addmath34.png",
  options: ["Slope changes from negative to positive", "Slope always positive", "Slope constant", "Slope zero everywhere"],
  answer: "Slope changes from negative to positive"
},

{
  question: "The diagram shows a normal to a curve. What is the relationship with tangent?",
  image: "/images/addmath35.png",
  options: ["Perpendicular", "Parallel", "Equal", "Opposite"],
  answer: "Perpendicular"
},

{
  question: "The diagram shows area under a curve. What does it represent?",
  image: "/images/addmath36.png",
  options: ["Integration", "Differentiation", "Gradient", "Intercept"],
  answer: "Integration"
},

{
  question: "The diagram shows a curve and shaded region. How is the area calculated?",
  image: "/images/addmath37.png",
  options: ["Integration", "Differentiation", "Multiplication", "Division"],
  answer: "Integration"
},

{
  question: "The diagram shows a curve increasing. What is the sign of the gradient?",
  image: "/images/addmath38.png",
  options: ["Positive", "Negative", "Zero", "Undefined"],
  answer: "Positive"
},

{
  question: "The diagram shows a curve decreasing. What is the gradient?",
  image: "/images/addmath39.png",
  options: ["Negative", "Positive", "Zero", "Constant"],
  answer: "Negative"
},

{
  question: "The diagram shows point of inflection. What happens at this point?",
  image: "/images/addmath40.png",
  options: ["Curve changes concavity", "Gradient is zero", "Maximum occurs", "Minimum occurs"],
  answer: "Curve changes concavity"
},

{
  question: "The diagram shows vectors AB and BC. What is the resultant vector AC?",
  image: "/images/addmath41.png",
  options: ["AB + BC", "AB - BC", "BC - AB", "AC only"],
  answer: "AB + BC"
},

{
  question: "The diagram shows a triangle with vectors. Which rule is applied?",
  image: "/images/addmath42.png",
  options: ["Triangle law", "Parallelogram law", "Cosine rule", "Sine rule"],
  answer: "Triangle law"
},

{
  question: "The diagram shows two vectors forming a parallelogram. What is the diagonal?",
  image: "/images/addmath43.png",
  options: ["Resultant vector", "Difference vector", "Zero vector", "Unit vector"],
  answer: "Resultant vector"
},

{
  question: "The diagram shows vectors in opposite directions. What is the result?",
  image: "/images/addmath44.png",
  options: ["Zero vector", "Maximum vector", "Positive vector", "Negative vector"],
  answer: "Zero vector"
},

{
  question: "The diagram shows a force acting on a body. What does the arrow represent?",
  image: "/images/addmath45.png",
  options: ["Magnitude and direction", "Mass", "Speed", "Time"],
  answer: "Magnitude and direction"
},

{
  question: "The diagram shows forces in equilibrium. What is the resultant force?",
  image: "/images/addmath46.png",
  options: ["Zero", "Maximum", "Minimum", "Undefined"],
  answer: "Zero"
},

{
  question: "The diagram shows motion graph (distance-time). What does slope represent?",
  image: "/images/addmath47.png",
  options: ["Speed", "Acceleration", "Force", "Energy"],
  answer: "Speed"
},

{
  question: "The diagram shows velocity-time graph. What does area under the graph represent?",
  image: "/images/addmath48.png",
  options: ["Displacement", "Speed", "Acceleration", "Force"],
  answer: "Displacement"
},

{
  question: "The diagram shows a triangle. Which theorem relates sides?",
  image: "/images/addmath49.png",
  options: ["Pythagoras theorem", "Sine rule", "Cosine rule", "Vector rule"],
  answer: "Pythagoras theorem"
},

{
  question: "The diagram shows angles in a triangle. What is the sum of angles?",
  image: "/images/addmath50.png",
  options: ["180°", "360°", "90°", "270°"],
  answer: "180°"
}
];

export default addMathsQuestions;


